import React, { useEffect, useState } from 'react';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IFormError from '../../interfaces/IFormError';
import debounce from 'lodash.debounce';
import { Autocomplete, CircularProgress, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ICompany from '../../interfaces/ICompany';
import { useCompanyService } from '../../hooks/services/useCompanyService';

interface IProps {
  setCompany: (company: ICompany | null) => void;
  company: ICompany | null;
}

const FollowupSearchCompany = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly ICompany[]>([]);
  const loadingInput = open;

  const request = useCompanyService();

  const toastr = useToastrVanila();

  const [errors, setErrors] = useState<IFormError | null>();

  useEffect(() => {
    let active = true;

    if (!loadingInput) {
      return undefined;
    }

    (async () => {
      if (active) {
        await loadCompanies(' - ');
      }
    })();

    return () => {
      active = false;
    };
  }, [loadingInput]);

  useEffect(() => {
    setErrors(null);
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const loadCompanies = debounce(async (filter = ' ') => {
    setLoading(true);
    await request
      .listCompanySearch(filter)
      .then(employees => {
        setOptions(employees);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoading(false);
      });
  }, 500);

  return (
    <Autocomplete
      open={open}
      value={props.company}
      onChange={(e: any, newValue) => {
        const castedCompany = { ...newValue } as ICompany;
        props.setCompany({ ...castedCompany });
      }}
      onOpen={() => {
        setOpen(true);
        props.setCompany(null);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => {
        return option?.name === value?.name;
      }}
      getOptionLabel={option => (option?.code && option.code ? `${option.code} - ${option.name}` : '')}
      options={options}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          placeholder="Filtrar por código ou nome"
          error={Boolean(errors?.code)}
          helperText={errors?.code}
          size="small"
          sx={{
            '& .MuiAutocomplete-inputRoot': { paddingTop: 0, paddingBottom: 0, paddingLeft: '10px' },
            '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
            },
          }}
          onChange={e => {
            loadCompanies(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <React.Fragment>
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default FollowupSearchCompany;
